import React, { useEffect, useState } from 'react'

import Button from 'components_new/atoms/Button'
import Modal from 'components/common/Modal'
import Input from 'components/common/Input'

import { DESCRIPTOR } from 'helpers/Constants'

const EditName = ({ visible, dataProduct, onClose, onSave }) => {
  const [name, setName] = useState(undefined)

  const descriptor = DESCRIPTOR[dataProduct.attributes.type]

  useEffect(() => {
    if (visible) {
      setName(dataProduct.attributes.name)
    }
  }, [visible])

  return (
    <Modal
      header={'Redigera namn'}
      visible={visible}
      onClose={() => onClose()}
      actions={
        <>
          <Button onClick={() => onClose()} variant="text">
            Avbryt
          </Button>
          <Button
            onClick={() => {
              onSave({ name })
              onClose()
            }}
          >
            Spara
          </Button>
        </>
      }
    >
      <Input
        size="large"
        label={`Namnge ${descriptor}`}
        value={name}
        onChange={(e) => setName(e)}
      />
    </Modal>
  )
}

export default EditName
